import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';

export class ContactCompanyBalanceMove {
  toContactId: string;
  companyId: string;
  amount: Money;
}

export class ContactBalanceMove {
  fromContactId: string;
  accountingDate: LocalDate;
  movements: ContactCompanyBalanceMove[];
}
